import styled from "styled-components";

export const TextContainer = styled.div`
    padding: 20px 40px;
    font-weight: 600;
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    box-sizing: border-box;
    gap: 20px;
    line-height: 1.3;
    overflow-y: auto;
    height: 100%;
    flex : 1;

    scrollbar-color: var(--background-accent-bis) rgba(0, 0, 0, 0.05); 
`